import {getCountryCode, getLanguageCode} from 'core/helpers/config';
import {compileURLTemplate} from 'core/helpers/url-builder';

import type {AssetViewerLoadOptions} from '../asset-viewer-types';

export class HPEAssetViewerURLUtils {
  protected static readonly QUERY_PARAMS = 'asset-id';
  protected static readonly SELECTOR_PATTERN = /\.(video|document|webpage)\.[^.]+\.([^.]+)/;

  protected static get url(): URL {
    return new URL(window.location.href);
  }

  public static findAssetIdFromSearchParams(): string | null {
    return this.url.searchParams.get(this.QUERY_PARAMS);
  }

  public static findAssetIdFromSelectors(): string | null {
    const match = this.SELECTOR_PATTERN.exec(this.url.pathname);
    return match ? match[2] : null;
  }

  public static findAssetId(): string | null {
    return this.findAssetIdFromSelectors() || this.findAssetIdFromSearchParams();
  }

  public static findAssetSubpath(): string | null {
    const match = this.SELECTOR_PATTERN.exec(this.url.pathname);
    return match ? match[0] : null;
  }

  public static getServiceUrl(id: string): string {
    const urlTemplate = '/services/hpe/asset.json?id={id}&cc={cc}&lc={lc}';
    const cc = getCountryCode();
    const lc = getLanguageCode();
    return compileURLTemplate(urlTemplate, {id, cc, lc});
  }

  public static buildUrl(id?: string, options: AssetViewerLoadOptions = {}): string {
    const {subpath, keepStartTime = false} = options;
    const {url} = this;

    const pathname = url.pathname.replace(this.SELECTOR_PATTERN, '');

    const htmlIndex = pathname.indexOf('.html');
    if (htmlIndex === -1) return;

    const prefix = pathname.substring(0, htmlIndex);
    const suffix = pathname.substring(htmlIndex);
    url.pathname = `${prefix}${subpath || ''}${suffix}`;
    !keepStartTime && url.searchParams.delete('t');

    url.searchParams.delete(this.QUERY_PARAMS);
    if (!subpath && id) url.searchParams.set(this.QUERY_PARAMS, id);

    return url.toString();
  }

  public static updateUrl(id?: string, options?: AssetViewerLoadOptions): void {
    window.history.pushState(null, document.title, this.buildUrl(id, options));
  }
}
